import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const Stat = ({ icon, label, value, sub, color }) => (
  <div className={`bg-white rounded-xl shadow p-5 border-r-4 ${color}`}>
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-500 text-sm">{label}</p>
        <p className="text-3xl font-bold text-gray-800 mt-1">{value}</p>
        {sub && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
      </div>
      <span className="text-4xl">{icon}</span>
    </div>
  </div>
);

const SuperDashboardPage = () => {
  const [stats, setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/companies/platform-stats')
      .then((r) => setStats(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-full p-20 text-blue-600 text-xl">جاري التحميل...</div>;
  if (!stats)  return <div className="p-10 text-red-500">فشل تحميل البيانات</div>;

  return (
    <div className="p-4 md:p-6 space-y-6" dir="rtl">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-gray-800">لوحة تحكم المدير العام</h1>
        <p className="text-gray-500 text-sm mt-1">نظرة عامة على منصة سافر</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <Stat icon="🏢" label="إجمالي الشركات" value={stats.totalCompanies}
          sub={`${stats.activeCompanies} نشطة · ${stats.pendingCompanies} معلقة`} color="border-blue-500" />
        <Stat icon="👥" label="إجمالي المسافرين" value={stats.totalPassengers.toLocaleString()}
          color="border-green-500" />
        <Stat icon="🎫" label="إجمالي الحجوزات" value={stats.totalBookings.toLocaleString()}
          sub={`${stats.recentBookings} في آخر 7 أيام`} color="border-purple-500" />
        <Stat icon="💰" label="إجمالي الإيرادات" value={`${stats.totalRevenue.toLocaleString()} SDG`}
          color="border-yellow-500" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Trips stats */}
        <div className="bg-white rounded-xl shadow p-5">
          <h2 className="font-bold text-gray-700 mb-4">📊 إحصائيات الرحلات</h2>
          <div className="space-y-3">
            <div className="flex justify-between items-center py-2 border-b">
              <span className="text-gray-600">إجمالي الرحلات</span>
              <span className="font-bold text-gray-800">{stats.totalTrips}</span>
            </div>
            <div className="flex justify-between items-center py-2 border-b">
              <span className="text-gray-600">رحلات مجدولة</span>
              <span className="font-bold text-green-600">{stats.activeTrips}</span>
            </div>
            <div className="flex justify-between items-center py-2">
              <span className="text-gray-600">شركات نشطة</span>
              <span className="font-bold text-blue-600">{stats.activeCompanies}</span>
            </div>
          </div>
        </div>

        {/* Top companies */}
        <div className="bg-white rounded-xl shadow p-5">
          <h2 className="font-bold text-gray-700 mb-4">🏆 أفضل الشركات (بالإيرادات)</h2>
          {stats.topCompanies.length === 0 ? (
            <p className="text-gray-400 text-sm text-center py-4">لا توجد بيانات بعد</p>
          ) : (
            <div className="space-y-3">
              {stats.topCompanies.map((c, i) => (
                <div key={c.id} className="flex items-center justify-between py-2 border-b last:border-0">
                  <div className="flex items-center gap-3">
                    <span className={`w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold text-white ${i === 0 ? 'bg-yellow-500' : i === 1 ? 'bg-gray-400' : i === 2 ? 'bg-orange-600' : 'bg-blue-400'}`}>
                      {i + 1}
                    </span>
                    <span className="text-gray-700 font-medium">{c.name}</span>
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-green-600">{parseFloat(c.revenue || 0).toLocaleString()} SDG</p>
                    <p className="text-xs text-gray-400">{c.bookingCount} حجز</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Pending approval notice */}
      {stats.pendingCompanies > 0 && (
        <div className="bg-yellow-50 border border-yellow-300 rounded-xl p-5 flex items-center gap-4">
          <span className="text-3xl">⏳</span>
          <div>
            <p className="font-bold text-yellow-800">شركات بانتظار الموافقة: {stats.pendingCompanies}</p>
            <p className="text-yellow-600 text-sm">يرجى مراجعة طلبات التسجيل الجديدة في صفحة إدارة الشركات.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperDashboardPage;
